/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelDivisionLookup.ts                *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/settlement/division-lookup";

export class AutogenModelDivisionLookup<RowType extends ModelRow> extends Endpoint<RowType, RowDivisionLookupFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowDivisionLookup extends ModelRow<RowDivisionLookupFields> {
	constructor(values?: Partial<RowDivisionLookupFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowDivisionLookupFields {
	company_id: string;
	descr: string;
	id: string;
}

